import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"
import { images } from "../../utils"

const useStyles = makeStyles((theme) => ({
  body: {
    display: "flex",
    flexDirection: "row",
    color: colors.greyStrong,
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.down("xl")]: {
      marginBottom: "89px",
    },
  },

  title: {
    "&.MuiTypography-root": {
      fontWeight: "bold",
      fontSize: "1.7em",
      color: colors.primary,
      textAlign: "center",
    },
  },

  search: {
    "&.MuiFormControl-root": {
      "& .MuiOutlinedInput-root": {
        "& .MuiOutlinedInput-input": {
          textAlign: "right",
        },
      },
    },
  },

  listHeader: {
    fontSize: "1rem",
  },

  subTitleContainer: {
    margin: "31px 0",
    textAlign: "center",
    [theme.breakpoints.down("xl")]: {
      margin: "32px 0 17px 0",
    },
  },

  subTitle: {
    [theme.breakpoints.down("lg")]: {
      "&.MuiTypography-root": {
        fontSize: "1.2em",
      },
    },
    [theme.breakpoints.up("lg")]: {
      "&.MuiTypography-root": {
        fontSize: "1.3em",
      },
    },
  },

  listContainer: {
    margin: "0 auto",
    width: "80%",
  },

  listBody: {
    marginTop: "50px",
    [theme.breakpoints.down("xl")]: {
      marginTop: "50px",
    },
  },

  inputButton: {
    "&.MuiButton-root": {
      width: "205px",
    },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "65px",
    [theme.breakpoints.down("lg")]: {
      marginTop: "50px",
    },
  },

  searchBar: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "55px",
    position: "relative",
    [theme.breakpoints.down("xl")]: {
      marginBottom: "50px",
    },
  },

  imgContainer: {
    backgroundImage: `url(${images.searchPqr})`,
    backgroundRepeat: "no-repeat",
    left: "0",
    bottom: "0",
    position: "absolute",
    zIndex: "-1",
    backgroundSize: "cover",
    [theme.breakpoints.down("xl")]: {
      display: "none",
    },
    [theme.breakpoints.up("xl")]: {
      width: "20%",
      bottom: "34px",
      height: "60%",
    },
  },
}))

export default useStyles
